import { render, staticRenderFns } from "./GeneralInfoContent.vue?vue&type=template&id=942a97ae&scoped=true&"
import script from "./GeneralInfoContent.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoContent.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoContent.vue?vue&type=style&index=0&id=942a97ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942a97ae",
  null
  
)

export default component.exports